import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';
import config from '../../config';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Corrected import
import ForgotModal from './ForgotModal'; // Create this component
import logo from '../../assets/img/Vector.png';

const Login = () => {
    const [UserName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(''); // State to track error messages
    const navigate = useNavigate();
    const [showForgotModal, setShowForgotModal] = useState(false);

    const validateForm = () => {
        // Check if fields are not empty
        if (!UserName || !password) {
            setError("Username and password are required.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear any previous errors

        if (!validateForm()) {
            return; // If validation fails, do not proceed
        }

        try {
            const response = await axios.post(`${config.API_BASE_URL}/login`, { UserName, password });

            // Decode JWT Token after successful login
            const token = response.data.token;
            const decodedToken = jwtDecode(token); // Use jwtDecode instead of jwt_decode

            // Store decoded token in localStorage or sessionStorage if needed
            localStorage.setItem('userData', JSON.stringify(decodedToken));

            // Redirect to dashboard or any other page
            navigate('/dashboards');
        } catch (error) {
            console.error('There was an error!', error);
            // Show error message if login fails
            if (error.response && error.response.status === 401) {
                setError('Invalid username or password.');
            } else {
                setError('An error occurred during login. Please try again.');
            }
        }
    };

    return (
        <div className="login-container">
            <div className="login-box-wrapper">
                <div className="logo-title-container">
                    <img src={logo} alt="Logo" className="logoimg" />
                    <p className="title">   
                        <strong className="pdq-text">PDQ</strong><br></br>
                        <strong className="subtitle-text">Payments Data Query</strong>
                    </p>
                </div>
                <div className="form-container">
                    <form className="form" onSubmit={handleSubmit}>
                        <div className="input-group">
                            <label htmlFor="username">Username</label>
                            <input
                                type="text"
                                name="username"
                                id="username"
                                placeholder=""
                                value={UserName}
                                onChange={(e) => setUserName(e.target.value)}
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                name="password"
                                id="password"
                                placeholder=""
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        <div className="forgot-section">
                            <span
                                className="forgot-link"
                                onClick={() => setShowForgotModal(true)}
                            >
                                <label className="custom-underline" onClick={() => setShowForgotModal(true)}>
                                    Forgot Username or Password?
                                </label>

                            </span>
                        </div>
                        <button type="submit" className="loginButton">
                            Login
                            <p className="arrow">&#11166;</p>
                        </button>
                        {error && <p className="error-message">{error}</p>}
                    </form>
                </div>
                {/* Modal for forgot password */}
                {showForgotModal && (
                    <ForgotModal closeModal={() => setShowForgotModal(false)} />
                )}
            </div>
        </div>
    );
};

export default Login;
